/**
 * api接口的统一出口
 */

import account from './account' // 账户相关接口
import verificationCode from './verificationCode' // 验证码相关接口
import userInfo from './userInfo' // userInfo用户信息模块接口列表
import meetingManage from './meetingManage' // meetingManage会议管理模块接口列表
import moneyUsering from './moneyUsering' // moneyUsering费用管理模块接口列表
import dictionary from './dictionary' // dictionary接口列表
import role from './role' // role接口列表

// 导出接口
export default {
  account,
  verificationCode,
  userInfo,
  meetingManage,
  moneyUsering,
  dictionary,
  role
}
